import { DashMessage } from "./DashMessage"
import { useDashboardDomainContext } from "../../../DashboardDomainProvider";
import { useCorePermissions } from "spark-core-dx/hooks";

export const NoVisualsMessage = () => {

    const { switchMode } = useDashboardDomainContext();
    const { canEdit } = useCorePermissions();

    return (
        <DashMessage
            icon={"page"}
            title={"No Visuals Yet"}
            description={canEdit("Dashboard") ? "Switch to design mode and drag across the grid to create the first visual on this page." : "This page has no visuals yet."}
            buttonText={canEdit("Dashboard") ? "Design Mode" : null}
            onClick={() => switchMode("design")}
        />
    )
}
